import { useContext } from 'react'
import { OnboardingFlowContext, OnboardingFlowContextType } from './context/OnboardingFlowContext'

export function useOnboardingFlow(): OnboardingFlowContextType {
    const context = useContext(OnboardingFlowContext)
    return context ?? { flowType: 'new-account' }
}
